var _path, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgReceipt(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 59,
    height: 46,
    viewBox: "0 0 59 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1505_1260",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 59,
    height: 46
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M58.7965 0.5H0.205078V45.5H58.7965V0.5Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1505_1260)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55.0164 33.0121H49.7809V18.507C54.4648 18.2537 58.2051 14.324 58.2051 9.5166C58.2051 4.7092 54.2105 0.5 49.3026 0.5H9.10329C4.19528 0.5 0.205078 4.54328 0.205078 9.5166C0.205078 14.49 3.94104 18.2537 8.6293 18.507V38.9286C8.6293 42.5526 11.5379 45.5 15.1144 45.5H49.6387C53.2152 45.5 56.1238 42.5526 56.1238 38.9286V34.1342C56.1238 33.5143 55.6283 33.0121 55.0164 33.0121ZM2.41993 9.5166C2.41993 5.78333 5.41904 2.74433 9.10329 2.74433H49.3069C52.9911 2.74433 55.9902 5.78333 55.9902 9.5166C55.9902 13.2499 53.2454 16.0138 49.7809 16.2627V10.6388H52.1077C52.7196 10.6388 53.2152 10.1366 53.2152 9.5166C53.2152 8.89656 52.7196 8.39443 52.1077 8.39443H6.30241C5.69051 8.39443 5.19497 8.89656 5.19497 9.5166C5.19497 10.1366 5.69051 10.6388 6.30241 10.6388H8.6293V16.2627C5.16481 16.0138 2.41993 13.0883 2.41993 9.5166ZM10.8398 38.9286V10.6344H47.566V43.2557H15.1101C12.7531 43.2557 10.8398 41.3127 10.8398 38.9286Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4136 17.3032H16.9942C16.3822 17.3032 15.8867 17.8053 15.8867 18.4254C15.8867 19.0454 16.3822 19.5475 16.9942 19.5475H41.4136C42.0255 19.5475 42.521 19.0454 42.521 18.4254C42.521 17.8053 42.0255 17.3032 41.4136 17.3032Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4136 23.3889H16.9942C16.3822 23.3889 15.8867 23.891 15.8867 24.5111C15.8867 25.1311 16.3822 25.6332 16.9942 25.6332H41.4136C42.0255 25.6332 42.521 25.1311 42.521 24.5111C42.521 23.891 42.0255 23.3889 41.4136 23.3889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4136 29.48H16.9942C16.3822 29.48 15.8867 29.9821 15.8867 30.6021C15.8867 31.2222 16.3822 31.7243 16.9942 31.7243H41.4136C42.0255 31.7243 42.521 31.2222 42.521 30.6021C42.521 29.9821 42.0255 29.48 41.4136 29.48Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.343 35.5657H23.0664C22.4545 35.5657 21.959 36.0679 21.959 36.6879C21.959 37.3079 22.4545 37.8101 23.0664 37.8101H35.343C35.9548 37.8101 36.4504 37.3079 36.4504 36.6879C36.4504 36.0679 35.9548 35.5657 35.343 35.5657Z",
    fill: "white"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReceipt);
export default __webpack_public_path__ + "static/media/receipt.dfa473d2fb96479ef63cea2d568db9f7.svg";
export { ForwardRef as ReactComponent };